// Keep complete colorway tiles and keyboard targets within two grid rows.
function initColorways(root) {
  if (root.dataset.collapseReady) return;
  const track = root.querySelector('.colorway-list__track');
  const button = root.querySelector('[data-colorway-toggle]');
  const text = root.querySelector('[data-colorway-toggle-text]');
  if (!track || !button || !text) return;
  root.dataset.collapseReady = 'true';
  let expanded = false;
  let width = -1;
  const update = () => {
    const items = [...track.children];
    items.forEach(item => item.removeAttribute('data-colorway-hidden'));
    const style = getComputedStyle(track);
    const columns = style.display === 'grid' ? style.gridTemplateColumns.split(' ').filter(Boolean).length : items.length;
    const limit = Math.max(1, columns) * 2;
    const remaining = Math.max(0, items.length - limit);
    button.hidden = remaining === 0;
    if (!remaining) expanded = false;
    if (!expanded) items.slice(limit).forEach(item => item.setAttribute('data-colorway-hidden', ''));
    button.setAttribute('aria-expanded', String(expanded));
    text.textContent = expanded ? 'Zobrazit méně barev' : `Zobrazit další barvy (${remaining})`;
  };
  button.addEventListener('click', () => {
    expanded = !expanded;
    update();
    if (!expanded && button.getBoundingClientRect().top < 0) {
      button.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
  });
  const observer = new ResizeObserver(entries => {
    const next = entries[0].contentRect.width;
    if (Math.abs(next - width) < 0.5) return;
    width = next;
    update();
  });
  observer.observe(track);
  update();
}
function initAll(scope = document) {
  scope.querySelectorAll('[data-colorway-collapse]').forEach(initColorways);
}
initAll();
document.addEventListener('shopify:section:load', event => initAll(event.target));
// Horizon can replace product content without a full page navigation.
new MutationObserver(records => {
  if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) initAll();
}).observe(document.body, { childList: true, subtree: true });
